import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {Observable} from 'rxjs/Observable';
import {IVehicleGroupForUserListRow} from '../../../_models/vehicle';
import {VehiclesGroupsService} from '../../../_services/vehicles-groups.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {catchError, finalize} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import { PaginationParams } from '../../../_models/generic';
import { IScheduleType } from 'app/_models/schedule-activity';
import { VehiclesFilesService } from 'app/_services/vehicles-files.service';

export class VehicleGroupDataSource implements DataSource<IScheduleType> {

    private vehiclesSubject = new BehaviorSubject<IScheduleType[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();
    public paginatorTotalCount: number;

    constructor(private vehiclegroupService: VehiclesFilesService) {

    }

    loadAdminVehicles(params: PaginationParams) {
        this.loadingSubject.next(true);

        this.vehiclegroupService.getScheduleTypes(params).pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe(vehicles => {
                console.log('find IScheduleType service in Datasource: ', vehicles);
                this.paginatorTotalCount = vehicles.count;
                this.vehiclesSubject.next(vehicles['results']);
            });

    }

    connect(collectionViewer: CollectionViewer): Observable<IScheduleType[]> {
        console.log("Connecting Vehicles Admin data source");
        return this.vehiclesSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.vehiclesSubject.complete();
        this.loadingSubject.complete();
    }

}




// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/dl-multi-select-schedule-types/schedule-types.datasource.ts